import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";

export const CvInput = ({ file, setFile, required, testId }) => (
  <label className="field flex items-center gap-3 cursor-pointer hover:border-[color:var(--gold)]" data-testid={`${testId}-label`}>
    <Upload size={16} className="text-gold" />
    <span className="text-sm text-slate-300 truncate">{file ? file.name : `Upload CV (PDF/DOC/DOCX, max 5MB)${required ? "" : " — optional"}`}</span>
    <input type="file" accept=".pdf,.doc,.docx" className="hidden" required={required} onChange={(e) => setFile(e.target.files[0])} data-testid={testId} />
  </label>
);

export const ApplyDialog = ({ job, onClose }) => {
  const [f, setF] = useState({ name: "", email: "", phone: "", languages: "", cover_note: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Please attach your CV");
    setBusy(true);
    const fd = new FormData();
    Object.entries({ ...f, job_id: job.id }).forEach(([k, v]) => fd.append(k, v));
    fd.append("cv", file);
    try {
      const r = await api.post("/public/applications", fd);
      setDone(r.data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!job} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white border-[color:var(--line)] max-w-lg" data-testid="apply-dialog">
        <DialogHeader><DialogTitle className="font-display text-gold">{job?.title}</DialogTitle></DialogHeader>
        {done ? (
          <div data-testid="apply-success">
            <p className="text-slate-300">Application received. Keep your tracking code:</p>
            <div className="font-data text-3xl text-gold my-4" data-testid="apply-tracking-code">{done.code}</div>
            <p className="text-xs text-slate-500">Track progress any time in “Track your application” using this code and your email.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="grid gap-3" data-testid="apply-form">
            <div className="text-xs text-slate-500">{job?.entity} · {job?.location} · {job?.language}</div>
            <input required className="field" placeholder="Full name" value={f.name} onChange={set("name")} data-testid="apply-name" />
            <div className="grid grid-cols-2 gap-3">
              <input required type="email" className="field" placeholder="Email" value={f.email} onChange={set("email")} data-testid="apply-email" />
              <input required className="field" placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="apply-phone" />
            </div>
            <input className="field" placeholder="Languages (e.g. Asante Twi, English, Ga)" value={f.languages} onChange={set("languages")} data-testid="apply-languages" />
            <textarea rows={3} className="field" placeholder="Why you? (short note)" value={f.cover_note} onChange={set("cover_note")} data-testid="apply-cover" />
            <CvInput file={file} setFile={setFile} required testId="apply-cv-input" />
            <button disabled={busy} className="btn-gold" data-testid="apply-submit-btn">{busy ? "Uploading…" : "Submit application"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
